// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.legacy-switch,\n.active-switch {\n  cursor: pointer;\n.vue-switcher__label {\n    position: absolute;\n    left: 42px;\n    bottom: -10px;\n    font-size: 0.9em;\n}\ninput[type='checkbox'] {\n    width: 1px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
